// extracted by mini-css-extract-plugin
module.exports = {"content":"content_content__AXn66","scroller":"content_scroller__RLn_G","header":"content_header__aKkOy"};